import React from 'react';
import { useRouteParams } from '../../utils/legacyUtils';
import PasswordReset from '../../../../../ui-kitchen/src/components/Form/PasswordResetForm';

const ResetPasswordController = (props) => {
  const $routeParamsShim = useRouteParams();
  return <PasswordReset $routeParams={$routeParamsShim} {...props} />;
};

export default ResetPasswordController;
